
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import formatPrice from "@/app/infrastructures/misc/common-library/v2/FormatPrice";
import { AccountController } from "@/app/ui/controllers/AccountController";
import {
  DistrictFieldRules,
  getFieldRulesForDistrict,
} from "@/app/infrastructures/misc/common-library/MalaysiaDistrictFieldRules";

class Props {
  detailData = prop<any>({
    type: Object,
    required: true,
  });
  districtFieldRules = prop<DistrictFieldRules>({
    type: Object,
    default: () => getFieldRulesForDistrict(null, "partner")
  });
}

@Options({
  components: {
    Title,
  },
  props: {
    detailData: {
      type: Object,
      required: true,
    },
  },
})
export default class DetailContractInformation extends Vue.with(Props) {
  get accountCurrency(): "IDR" | "MYR" {
    const cc = AccountController.accountData?.countryCode?.toLowerCase();
    return cc === "my" ? "MYR" : "IDR";
  }

  convertDate(date: string) {
    return formatDate(date);
  }

  convertCurrency(value: number) {
    return formatPrice(value, "", this.districtFieldRules.currencyCode as "IDR" | "MYR");
  }
}
